export const POSITION_LEVEL_LIST = [
  { position_level: 'Internship', value: 7, id: 7 },
  { position_level: 'Non-executive', value: 1, id: 1 },
  { position_level: 'Entry-level', value: 2, id: 2 },
  { position_level: 'Junior Executive', value: 3, id: 3 },
  { position_level: 'Senior Executive', value: 4, id: 4 },
  { position_level: 'Manager', value: 5, id: 5 },
  { position_level: 'Senior Manager', value: 6, id: 6 },
]

export const GRADE_LIST = [
  { grade: 'First Class (CGPA > 3.5)', value: 3.5 },
  { grade: 'Second Class Upper (CGPA > 3.0)', value: 3.0 },
  { grade: 'Second Class Lower (CGPA > 2.5)', value: 2.5 },
  { grade: 'No minimum grade requirement', value: 0 },
]

export const CITY_IN_MALAYSIA_LIST = [
  { name: 'Pasir Gudang' },
  { name: 'Bukit Indah' },
  { name: 'Skudai' },
  { name: 'Kluang' },
  { name: 'Batu Pahat' },
  { name: 'Muar' },
  { name: 'Ulu Tiram' },
  { name: 'Senai' },
  { name: 'Segamat' },
  { name: 'Kulai' },
  { name: 'Kota Tinggi' },
  { name: 'Pontian Kechil' },
  { name: 'Tangkak' },
  { name: 'Bukit Bakri' },
  { name: 'Yong Peng' },
  { name: 'Pekan Nenas' },
  { name: 'Labis' },
  { name: 'Mersing' },
  { name: 'Simpang Renggam' },
  { name: 'Parit Raja' },
  { name: 'Kelapa Sawit' },
  { name: 'Buloh Kasap' },
  { name: 'Chaah' },
  { name: 'Sungai Petani' },
  { name: 'Alor Setar' },
  { name: 'Kulim' },
  { name: 'Jitra / Kubang Pasu' },
  { name: 'Baling' },
  { name: 'Pendang' },
  { name: 'Langkawi' },
  { name: 'Yan' },
  { name: 'Sik' },
  { name: 'Kuala Nerang' },
  { name: 'Pokok Sena' },
  { name: 'Bandar Baharu' },
  { name: 'Sungai Petani' },
  { name: 'Alor Setar' },
  { name: 'Kulim' },
  { name: 'Jitra / Kubang Pasu' },
  { name: 'Baling' },
  { name: 'Pendang' },
  { name: 'Langkawi' },
  { name: 'Yan' },
  { name: 'Sik' },
  { name: 'Kuala Nerang' },
  { name: 'Pokok Sena' },
  { name: 'Bandar Baharu' },
  { name: 'Bandaraya Melaka' },
  { name: 'Bukit Baru' },
  { name: 'Ayer Keroh' },
  { name: 'Klebang' },
  { name: 'Masjid Tanah' },
  { name: 'Sungai Udang' },
  { name: 'Batu Berendam' },
  { name: 'Alor Gajah' },
  { name: 'Bukit Rambai' },
  { name: 'Ayer Molek' },
  { name: 'Bemban' },
  { name: 'Kuala Sungai Baru' },
  { name: 'Pulau Sebang' },
  { name: 'Seremban' },
  { name: 'Port Dickson' },
  { name: 'Nilai' },
  { name: 'Bahau' },
  { name: 'Tampin' },
  { name: 'Kuala Pilah' },
  { name: 'Kuantan' },
  { name: 'Temerloh' },
  { name: 'Bentong' },
  { name: 'Mentakab' },
  { name: 'Raub' },
  { name: 'Jerantut' },
  { name: 'Pekan' },
  { name: 'Kuala Lipis' },
  { name: 'Bandar Jengka' },
  { name: 'Bukit Tinggi' },
  { name: 'Ipoh' },
  { name: 'Taiping' },
  { name: 'Sitiawan' },
  { name: 'Simpang Empat' },
  { name: 'Teluk Intan' },
  { name: 'Batu Gajah' },
  { name: 'Lumut' },
  { name: 'Kampung Koh' },
  { name: 'Kuala Kangsar' },
  { name: 'Sungai Siput Utara' },
  { name: 'Tapah' },
  { name: 'Bidor' },
  { name: 'Parit Buntar' },
  { name: 'Ayer Tawar' },
  { name: 'Bagan Serai' },
  { name: 'Tanjung Malim' },
  { name: 'Lawan Kuda Baharu' },
  { name: 'Pantai Remis' },
  { name: 'Kampar' },
  { name: 'Kangar' },
  { name: 'Kuala Perlis' },
  { name: 'Bukit Mertajam' },
  { name: 'Georgetown' },
  { name: 'Sungai Ara' },
  { name: 'Gelugor' },
  { name: 'Ayer Itam' },
  { name: 'Butterworth' },
  { name: 'Val d’Or' },
  { name: 'Perai' },
  { name: 'Nibong Tebal' },
  { name: 'Permatang Kucing' },
  { name: 'Tanjung Tokong' },
  { name: 'Kepala Batas' },
  { name: 'Tanjung Bungah' },
  { name: 'Juru' },
  { name: 'Kota Kinabalu' },
  { name: 'Sandakan' },
  { name: 'Tawau' },
  { name: 'Lahad Datu' },
  { name: 'Keningau' },
  { name: 'Putatan' },
  { name: 'Donggongon' },
  { name: 'Semporna' },
  { name: 'Kudat' },
  { name: 'Kunak' },
  { name: 'Papar' },
  { name: 'Ranau' },
  { name: 'Beaufort' },
  { name: 'Kinarut' },
  { name: 'Kota Belud' },
  { name: 'Kuching' },
  { name: 'Miri' },
  { name: 'Sibu' },
  { name: 'Bintulu' },
  { name: 'Limbang' },
  { name: 'Sarikei' },
  { name: 'Sri Aman' },
  { name: 'Kapit' },
  { name: 'Batu Delapan Bazaar' },
  { name: 'Kota Samarahan' },
  { name: 'Subang Jaya' },
  { name: 'Klang' },
  { name: 'Ampang Jaya' },
  { name: 'Shah Alam' },
  { name: 'Petaling Jaya' },
  { name: 'Cheras' },
  { name: 'Kajang' },
  { name: 'Selayang Baru' },
  { name: 'Rawang' },
  { name: 'Taman Greenwood' },
  { name: 'Semenyih' },
  { name: 'Banting' },
  { name: 'Balakong' },
  { name: 'Gombak Setia' },
  { name: 'Kuala Selangor' },
  { name: 'Serendah' },
  { name: 'Bukit Beruntung' },
  { name: 'Pengkalan Kundang' },
  { name: 'Jenjarom' },
  { name: 'Sungai Besar' },
  { name: 'Batu Arang' },
  { name: 'Tanjung Sepat' },
  { name: 'Kuang' },
  { name: 'Kuala Kubu Baharu' },
  { name: 'Batang Berjuntai' },
  { name: 'Bandar Baru Salak Tinggi' },
  { name: 'Sekinchan' },
  { name: 'Sabak' },
  { name: 'Tanjung Karang' },
  { name: 'Beranang' },
  { name: 'Sungai Pelek' },
  { name: 'Kuala Terengganu' },
  { name: 'Chukai' },
  { name: 'Dungun' },
  { name: 'Kerteh' },
  { name: 'Kuala Berang' },
  { name: 'Marang' },
  { name: 'Paka' },
  { name: 'Jerteh' },
  { name: 'Labuan' },
  { name: 'Putrajaya' },
  { name: 'Johor' },
  { name: 'Kedah' },
  { name: 'Kelantan' },
  { name: 'Melaka' },
  { name: 'Negeri Sembilan' },
  { name: 'Pahang' },
  { name: 'Perak' },
  { name: 'Perlis' },
  { name: 'Pulau Pinang' },
  { name: 'Sarawak' },
  { name: 'Selangor' },
  { name: 'Terengganu' },
  { name: 'Kuala Lumpur' },
  { name: 'Labuan' },
  { name: 'Sabah' },
  { name: 'Putrajaya' },
]

export const STATE_IN_MALAYSIA_LIST = [
  { name: 'Johor', id: 1 },
  { name: 'Kedah', id: 2 },
  { name: 'Kelantan', id: 3 },
  { name: 'Melaka', id: 4 },
  { name: 'Negeri Sembilan', id: 5 },
  { name: 'Pahang', id: 6 },
  { name: 'Perak', id: 7 },
  { name: 'Perlis', id: 8 },
  { name: 'Pulau Pinang', id: 9 },
  { name: 'Sarawak', id: 10 },
  { name: 'Selangor', id: 11 },
  { name: 'Terengganu', id: 12 },
  { name: 'Sabah', id: 13 },
  { name: 'Wilayah Persekutuan Kuala Lumpur', id: 14 },
  { name: 'Wilayah Persekutuan Putrajaya', id: 15 },
  { name: 'Wilayah Persekutuan Labuan', id: 16 },
  //   { name: "Kuala Lumpur", id: 17 },
  //   { name: "Putrajaya", id: 18 },
  //   { name: "Labuan", id: 19 },
]
